import styled from 'styled-components';

export const MasterWrap = styled.div``;
